import { Injectable } from '@angular/core';
import { ActiveWorkCenterService } from '@app/core/workcenter';
import { ActiveOrderDsService } from '../active-order-ds/active-order-ds.service';
import { MachineCounterQuery, MachineCounterService } from '@app/core/global-state';
import * as R from 'ramda';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { Quantity, WebSocketClientService, WorkCenterCounter } from 'chronos-core-client';
import { HubUrlsService } from '@app/core/utils';
import { WorkCenterService } from 'chronos-core-client';

@Injectable({
  providedIn: 'root'
})
export class MachineCounterDsService {
  constructor(
    private workCenterService: WorkCenterService,
    private activeWorkCenterService: ActiveWorkCenterService,
    private machineCounterService: MachineCounterService,
    private machineCounterQuery: MachineCounterQuery,
    private activeOrderDsService: ActiveOrderDsService,
    private webSocketClientService: WebSocketClientService,
    private hubUrlsService: HubUrlsService
  ) {}

  private getCurrentCounter(): Observable<WorkCenterCounter> {
    const workCenterId = this.activeWorkCenterService.getWorkCenterId();

    return this.workCenterService.getCurrentCounter({ workCenterId });
  }

  public renewMachineSpeed(): Observable<Quantity> {
    return this.getCurrentCounter().pipe(
      tap((machineCounter) => {
        this.updateMachineCounter({ speed: machineCounter.speed });
      }),
      map((machineCounter) => machineCounter.speed)
    );
  }

  public renewMachineCounter(): void {
    this.getCurrentCounter().subscribe((machineCounter) => {
      this.updateMachineCounter(machineCounter);
    });
  }

  public getMachineSpeedFromStore(): Observable<Quantity> {
    return this.machineCounterQuery.getMachineCounter().pipe(map(x => x.speed), distinctUntilChanged());
  }

  public getMachineCounterFromStore(): Observable<Quantity> {
    return combineLatest([this.machineCounterQuery.getMachineCounter(), this.activeOrderDsService.selectRunPhaseStartCounter()]).pipe(
      map(([machineCounter, runPhaseStartCounter]) => {
        if (machineCounter?.counter === null || runPhaseStartCounter === null) {
          return null;
        }

        return {
          value: machineCounter.counter.value - runPhaseStartCounter,
          unitId: machineCounter.counter.unitId
        };
      })
    );
  }

  private updateMachineCounter(machineCounter: Partial<WorkCenterCounter>): void {
    this.machineCounterService.updateMachineCounter(machineCounter);
  }

  public getCounterNotifications(): Observable<WorkCenterCounter> {
    return this.webSocketClientService.getNotificationsForTopic<WorkCenterCounter>(this.hubUrlsService.getCounterValue()).pipe(
      tap((machineCounter: WorkCenterCounter) => {
        this.updateMachineCounter(machineCounter);
      })
    );
  }
}
